import { PeriodIso } from '@/app/shared/utils/period.utils';

export const CATALOG_PAGE_SIZE = 50;
export const PLAN_NAME_MAX_LENGTH = 30;
export const GROUP_NAME_MAX_LENGTH = 80;
export const ALL_PLANS_LABEL = 'Todos los planes';
export const ALL_GROUPS_LABEL = 'Todos los grupos';

export interface CatalogPage<T> {
  items: T[];
  hasMore: boolean;
}

export interface PlanOption {
  name: string;
}

export interface GroupOption {
  groupId: number;
  groupName: string;
}

export interface CatalogSearch {
  search: string;
  size: number;
}

export interface RegistryCatalogQuery extends CatalogSearch {
  period?: PeriodIso;
}

export interface ReportingCatalogQuery extends CatalogSearch {
  from: PeriodIso;
  to: PeriodIso;
}
